import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { formatDateTime } from "@/lib/format";

interface Strategy {
  _id: string;
  name: string;
  version: number;
  status: "ACTIVE" | "PAUSED" | "DISABLED";
  description?: string;
  updatedAt: string;
}

export default function Strategies() {
  const { data: strategiesResp, isLoading, error } = useQuery<{ data: Strategy[] }>({
    queryKey: ["strategies"],
    queryFn: () => api.get("/strategies"),
  });
  const strategies = strategiesResp?.data ?? [];

  return (
    <div>
      <h1 style={{ fontSize: 22, fontWeight: 700, marginBottom: 20 }}>
        Strategies
      </h1>

      <div className="card">
        {isLoading && <div style={{ padding: 20, color: "var(--text-muted)" }}>Loading strategies…</div>}
        {error && <div style={{ padding: 20, color: "var(--red-light)" }}>Error: {error.message}</div>}
        {strategies && strategies.length === 0 && (
          <div style={{ padding: 20, color: "var(--text-muted)" }}>No strategies configured</div>
        )}
        {strategies && strategies.length > 0 && (
          <table>
            <thead>
              <tr>
                <th>Name</th>
                <th>Version</th>
                <th>Status</th>
                <th>Description</th>
                <th>Last Updated</th>
              </tr>
            </thead>
            <tbody>
              {strategies.map((s) => {
                const statusColor = s.status === "ACTIVE"
                  ? "var(--green-light)"
                  : s.status === "PAUSED"
                    ? "var(--amber)"
                    : "var(--text-muted)";
                return (
                  <tr key={s._id}>
                    <td style={{ fontWeight: 600 }}>{s.name}</td>
                    <td style={{ fontFamily: "var(--font-mono)" }}>v{s.version}</td>
                    <td>
                      <span style={{ fontSize: 11, fontWeight: 700, color: statusColor, textTransform: "uppercase" }}>
                        {s.status}
                      </span>
                    </td>
                    <td style={{ fontSize: 13, color: "var(--text-muted)" }}>{s.description || "—"}</td>
                    <td style={{ fontSize: 12, color: "var(--text-muted)" }}>{formatDateTime(s.updatedAt)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
